(() => {
  const dialog=document.querySelector('#InquiryDialog');
  const form=document.querySelector('#InquiryForm');
  const context=document.querySelector('#inquiry-context');
  const message=document.querySelector('#inquiry-message');
  const status=document.querySelector('#inquiry-status');
  let opener=null;
  document.querySelectorAll('[data-inquire]').forEach(link=>link.addEventListener('click',event=>{
    event.preventDefault();
    opener=link;
    context.textContent=link.dataset.inquire;
    message.value=link.dataset.inquire==='General inquiry'?'':`I would like to know more about ${link.dataset.inquire}.`;
    status.textContent='';
    document.querySelector('.menu-shell')?.removeAttribute('open');
    dialog.showModal();
  }));
  dialog.querySelector('[data-close-dialog]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>opener?.focus());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const box=dialog.getBoundingClientRect();
    if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();
  });
  form.addEventListener('submit',event=>{
    event.preventDefault();
    if(!form.reportValidity())return;
    const name=document.querySelector('#inquiry-name').value.trim();
    const body=`Hello Mr G Fine Art,\n\n${message.value.trim()}\n\nName: ${name}`;
    window.location.href=`mailto:mrgfineartt@gmail.com?subject=${encodeURIComponent(context.textContent)}&body=${encodeURIComponent(body)}`;
    status.textContent='Your message is ready in your email app. Please review and send it there. If no email app opens, use the address below.';
  });
  document.querySelectorAll('.menu-panel a').forEach(link=>link.addEventListener('click',()=>link.closest('details').removeAttribute('open')));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelector('.menu-shell')?.removeAttribute('open');});
  // Keep the mobile purchase action, but do not duplicate it while the main
  // purchase button is fully visible. Hidden also removes it from tab order.
  const orderBar=document.querySelector('.mobile-order-bar');
  const primaryOrder=document.querySelector('.product-panel .order-request');
  if(orderBar&&primaryOrder&&'IntersectionObserver' in window){
    const orderVisibility=new IntersectionObserver(([entry])=>{
      orderBar.hidden=entry.isIntersecting&&entry.intersectionRatio>=0.9;
    },{threshold:[0,0.9,1],rootMargin:'0px 0px -88px 0px'});
    orderVisibility.observe(primaryOrder);
  }
  document.querySelectorAll('.film-archive').forEach(details=>details.addEventListener('toggle',()=>{
    const video=details.querySelector('video');
    if(!video)return;
    if(details.open&&!video.dataset.loaded){
      video.poster=video.dataset.poster||'';
      video.querySelectorAll('source[data-src]').forEach(source=>source.src=source.dataset.src);
      video.preload='metadata';video.load();video.dataset.loaded='true';
    }else if(!details.open)video.pause();
  }));
})();
